import {SisName} from 'util/SisName'
import {PersInfCode} from 'module/PersonInfo/type/PersInfCode'
import {EntryDesc} from 'generated/JavaTOmodifications'

export interface PersInfCodeFKey {
	code: PersInfCode,
	fkey: string
}

export const FALLBACK = [{code: PersInfCode.FALLBACK_EVENT_DIALOG, fkey: ''}]

export function getPersInfCodeFKeyListForEntryDesc(entryDesc?: EntryDesc): PersInfCodeFKey[] {
	if (!entryDesc) return FALLBACK
	const {sisName, bookingType, hourCategory} = entryDesc || {}
	switch (sisName) {
		case SisName.Booking:
			return [
				{code: PersInfCode.BOOKING_EVENT, fkey: bookingType},
				{code: PersInfCode.BOOKING_STUART_EVENT, fkey: `${bookingType}:${hourCategory?.trim() || ''}`},
			]
		case SisName.Persurl:
			return [{code: PersInfCode.PERSURL_EVENT, fkey: hourCategory}]
		default:
			return FALLBACK
	}
}